export default "__VITE_ASSET__180922cd__"